module.exports = __webpack_public_path__ + "static/media/img19.6f00f6e2.jpg";